import axios from 'axios';
import { call } from './utils';

const backendURL = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_BACKEND_URL_DEV : process.env.REACT_APP_BACKEND_URL_PROD;
export const loginUser = async (data) => {
  return await axios
    .post(backendURL + '/api/auth/signin/user', {
      email: data.email,
      password: data.password
    })
    .then((response) => {
      return response;
    })
    .catch((err) => {
      //catch error
      if (!err?.response) return Promise.reject("Errore server, contattare l'assistenza!");
      if (err.response?.status == 500) return Promise.reject("Errore server, contattare l'assistenza!");
      return err.response;
    });
};
export const loginUserSocial = async (data) => {
  return await axios
    .post(backendURL + '/api/auth/signin/user/mobile', {
      email: data.email
    })
    .then((response) => {
      return response;
    })
    .catch((err) => {
      //catch error
      if (!err?.response) return Promise.reject("Errore server, contattare l'assistenza!");
      if (err.response?.status == 500) return Promise.reject("Errore server, contattare l'assistenza!");
      return err.response;
    });
};

export const registerUser = async (data) => {
  return await axios
    .post(backendURL + '/api/auth/signup/user', data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      //catch error
      if (!err?.response) return Promise.reject("Errore server, contattare l'assistenza!");
      if (err.response?.status == 500) return Promise.reject("Errore server, contattare l'assistenza!");
      return err.response;
    });
};

export const changePassword = async (data) => {
  await axios
    .post(backendURL + '/api/auth/change-password', data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      //catch error
      if (!err?.response) return Promise.reject("Errore server, contattare l'assistenza!");
      if (err.response?.status == 500) return Promise.reject("Errore server, contattare l'assistenza!");
      return err.response;
    });
};

export const logoutUser = async (data, token) => await call({ url: '/api/auth/signout/user', data, token, method: 'POST' });
